import React, { useEffect } from "react";
import ModalDetailsRow from "../../../components/ModalDetailsRow/ModalDetailsRow.component";
import { Loader } from "../../../UI/Loaders/Loaders";
import { MixPanel } from "../../../shared/MixPanel/MixPanel";
import useAuditTrailDetails from "../../../custom-hooks/useAuditTrailDetails";

interface AuditTrailModalProps {
  properties: {
    dataRecord: {
      action_date: string;
      audit_type: string;
      username: string;
      client_ip_address: string;
      id: string;
    };
    type: string;
  };
  onCloseModal: () => void;
}

const AuditTrailModal: React.FC<AuditTrailModalProps> = ({
  properties,
  properties: { dataRecord, type },
  onCloseModal,
}) => {
  const printHandler = () => {};
  const { action_date, audit_type, username, client_ip_address, id } =
    dataRecord;
  useEffect(() => {
    MixPanel.track(`Page View: AuditTrail.tsx`, {
      page: "AuditTrail.tsx",
    });
  }, []);

  const { data: auditTrailData, isLoading } = useAuditTrailDetails({
    auditTrailId: id,
  });

  console.log("auditTrailData", auditTrailData);

  return (
    <div
      className="Modal__dialog md-modal animated slideInDown"
      role="document"
    >
      <div
        className="AuditTrailModal Modal__content"
        style={{ overflow: "hidden" }}
      >
        {(() => {
          switch (type) {
            case "alert":
              return (
                <div className="text-center Modal__body">
                  <h3 className="text-center Modal__title p-b-2">
                    Invalid date range
                  </h3>
                  <button
                    type="button"
                    className="btn zoom-element login-btn m-t-1"
                    onClick={onCloseModal}
                    data-dismiss="modal"
                  >
                    <i className="fas fa-times-circle"></i>
                    &nbsp; Go Back
                  </button>
                </div>
              );
            default:
              return (
                <div className="Modal__body">
                  <h3 className="text-center Modal__title p-b-2">
                    Audit Trail Information
                  </h3>
                  {/* AuditTrail ModalContainer */}
                  {isLoading ? (
                    <Loader text="Loading audit trail details..." centered />
                  ) : (
                    <form>
                      {auditTrailData?.data?.customerDetails && (
                        <>
                          <div className="row">
                            <div className="col-6">
                              <ModalDetailsRow
                                label="Customer First Name"
                                value={
                                  auditTrailData.data.customerDetails.firstName
                                }
                                icon="fas fa-user-circle"
                              />
                            </div>
                            <div className="col-6">
                              <ModalDetailsRow
                                label="Customer Last Name"
                                value={
                                  auditTrailData.data.customerDetails.lastName
                                }
                                icon="fas fa-user-circle"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <ModalDetailsRow
                                label="Customer Email"
                                value={
                                  auditTrailData.data.customerDetails.email
                                }
                                icon="fas fa-envelope"
                              />
                            </div>
                            <div className="col-6">
                              <ModalDetailsRow
                                label="Customer Phone Number"
                                value={
                                  auditTrailData.data.customerDetails
                                    .phoneNumber
                                }
                                icon="fas fa-phone"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <ModalDetailsRow
                                label="Customer ID"
                                value={
                                  auditTrailData.data.customerDetails.customerId
                                }
                                icon="fas fa-id-card"
                              />
                            </div>
                          </div>
                        </>
                      )}
                      <div className="row">
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Username"
                            value={username}
                            icon="fas fa-user-circle"
                          />
                        </div>
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Client IP Address"
                            value={client_ip_address}
                            icon="fas fa-network-wired"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Action"
                            value={auditTrailData?.data?.action}
                            icon="fas fa-bolt"
                          />
                        </div>
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Entity Name"
                            value={auditTrailData?.data?.entityName}
                            icon="fas fa-tag"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Initiator First Name"
                            value={
                              auditTrailData?.data?.initiatedByDetails
                                ?.firstName
                            }
                            icon="fas fa-user-circle"
                          />
                        </div>
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Initiator Last Name"
                            value={
                              auditTrailData?.data?.initiatedByDetails?.lastName
                            }
                            icon="fas fa-user-circle"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Initiator Email"
                            value={
                              auditTrailData?.data?.initiatedByDetails?.email
                            }
                            icon="fas fa-envelope"
                          />
                        </div>
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Initiator UserId"
                            value={
                              auditTrailData?.data?.initiatedByDetails?.userId
                            }
                            icon="fas fa-id-badge"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <ModalDetailsRow
                            label="Date/Time"
                            value={`${auditTrailData?.data?.actionDate.substring(0, 10)} / ${auditTrailData?.data?.actionDate.substring(11, 19)}`}
                            icon="far fa-clock"
                          />
                        </div>
                      </div>
                      <ModalDetailsRow
                        label="Comment"
                        value={auditTrailData?.data?.comment}
                        icon="fas fa-comment-alt"
                        type="textarea"
                        rows={4}
                      />

                      <div className="Form__action-buttons m-t-1">
                        {/* <button
                        type="button"
                        className="m-0 mr-auto btn zoom-element login-btn"
                        onClick={printHandler}
                      >
                        <i className="fas fa-print"></i>
                        &nbsp; Print
                      </button> */}
                        <button
                          type="button"
                          className="btn zoom-element btn login-btn m-0 ml-auto"
                          onClick={onCloseModal}
                          data-dismiss="modal"
                        >
                          <i className="fas fa-times-circle"></i>
                          &nbsp; Go Back
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              );
          }
        })()}
      </div>
    </div>
  );
};

export default AuditTrailModal;
